<script setup>
import {ClipboardCopyIcon, CheckCircleIcon} from "@heroicons/vue/outline";
import {Clipboard} from "v-clipboard";
import {ref, computed, onMounted} from "vue";

const props = defineProps({
    content: {
        type: Object,
        required: true,
    },
})

const copyState = ref('')

const alignmentClass = computed(() => {
    return props.content?.alignment === 'left' ? 'text-left' : props.content?.alignment === 'right' ? 'text-right' : 'text-center';
})

const containerClasses = computed(() => {
    const classes = ['flex', 'items-center', 'gap-2'];

    // Alignment
    if (props.content?.alignment === 'center') {
        classes.push('justify-center');
    } else if (props.content?.alignment === 'right') {
        classes.push('justify-end');
    } else {
        classes.push('justify-start');
    }

    return classes.join(' ');
})

// Extract plain text from HTML for copying
const getPlainText = (html) => {
    if (!html) return '';
    html = html.replace(/<br\s*\/?>/gi, '\n');
    html = html.replace(/<\/p>/gi, '\n');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
}

const copyToClipboard = async () => {
    if (!props.content?.text) return;
    // Copy plain text version (strip HTML tags)
    const plainText = getPlainText(props.content.text);
    let res = await Clipboard.copy(plainText)
    copyState.value = res ? 'success' : 'error'
    setTimeout(() => {
        copyState.value = ''
    }, 2000)
}

onMounted(() => {
    if (!props.content.version) {
        props.content.version = 1;
    }
})
</script>

<template>
    <div>
        <div :class="containerClasses">
            <div class="flex-1" :class="alignmentClass" v-html="content?.text"></div>
            <button-secondary
                @click="copyToClipboard"
                :state="copyState"
                :title="_mft('blocks:copy-to-clipboard.button')"
                class="flex-shrink-0"
            >
                <ClipboardCopyIcon v-if="copyState !== 'success'" class="h-4 w-4" />
                <CheckCircleIcon v-else class="h-4 w-4 text-green-600" />
            </button-secondary>
        </div>
    </div>
</template>

<style scoped>
:deep(ul) {
    list-style-type: disc;
    padding-left: 1em;
}
:deep(ol) {
    list-style-type: decimal;
    padding-left: 1em;
}
</style>

